import { z } from 'zod';
import { IdZ, TsZ } from './common';

/**
 * Stats badges (v1 list from RULINGS v1 scope). Stats may add codes later, so the column
 * and schema take any short string; this list is the reference. Lab badges (lab_rat,
 * mad_scientist) live in Game Lab's own table and never in badges_earned (A6).
 */
export const BADGE_CODES_V1 = [
  'splash_zone',
  'ice_veins',
  'sniper',
  'around_the_world',
  'perfect_game',
  'bagel',
  'comeback_kid',
  'streaker',
  'giant_slayer',
  'combine_grad',
] as const;

export const BadgeEarnedZ = z.object({
  playerId: IdZ,
  badge: z.string().min(1).max(40),
  tier: z.number().int().min(1).max(5),
  unlockedAt: TsZ,
  sourceId: z.string().nullable(),
});
export type BadgeEarned = z.infer<typeof BadgeEarnedZ>;
